import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiService, { handleError } from "../Common/ApiCommon/ApiService";

// Async thunk to fetch store details
export const getStoresDetails = createAsyncThunk(
  "store/getStoreName",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.get("/vendors/get_store_name");
      return response.data;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

const storeSlice = createSlice({
  name: "store", 
  initialState: {
    loading: false,
    error: null,
    data: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStoresDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStoresDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getStoresDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default storeSlice.reducer;
